export const getRandomClientNumber = (total: number) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const crypto = window.crypto || (window as any).msCrypto;
  if (crypto) {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    const randomNumber = array[0] % total;
    const result = Math.floor(randomNumber);

    if (total < 1) return 0;
    return result;
  } else {
    // eslint-disable-next-line no-console
    console.warn('crypto.getRandomValues is not available in this browser.');
    return 0;
  }
};
